<style lang="stylus">
    .outputPPT-mask
        modal-mask()
        .outputPPT-modal
            .outputPPT-container
                width 480px
                .outputPPT-box
                    display flex
                    flex-wrap wrap
                    margin-bottom 12px
                    .outputPPT-optionbox-title
                        font-size 12px
                        line-height 24px
                        width 70px
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                    .right
                        width calc(100% - 76px)
                        margin-left 6px
                        display flex
                        flex-wrap wrap
                        align-items center
                        .check-box-item
                            height 24px
                            padding 0 16px
                            border 1px solid var(--border-color-gray-10)
                            border-radius 6px
                            margin 0 16px 8px 0
                            display flex
                            align-items center
                            &:last-child
                                margin-right 0
                            &.checked
                                position relative
                                border-color var(--themeColor)
                                .tick-icon
                                    display block
                            &:hover
                                border-color var(--themeColor)
                            .tick-icon
                                display none
                                position absolute
                                top 0
                                right 0
                                height 18px
                                width 18px;
                                color var(--themeColor)
                            .vip-icon
                                margin-right 8px
                                width 12px
                                height 12px
                    .outputImg-selector
                        .ivu-select-item
                            display flex
                            align-items center
                            position relative
                        .vip-icon
                            margin-left 8px
                .outputPPT-shapebox
                    padding-bottom 12px
                    border-bottom 1px solid var(--border-color-gray-10)
                .outputPPT-watermarkBox
                    margin-bottom 4px
                .outputPPT-zoombox
                    .ivu-input-number
                        .ivu-input-number-handler-wrap, .ivu-input-number-input
                                background-color var(--bg-color-tertiary)
                    .ivu-slider
                        width 260px
                        margin-right 16px
                        .ivu-slider-wrap
                            margin 0
                            .ivu-slider-button
                                background-color var(--bg-color-tertiary)
                .outputPPT-otherbox
                    .right
                        .export-setting
                            position relative
                            margin-right 24px
                            position relative
                            margin-bottom 5px
                            display flex
                            align-items center
                            .vip-icon
                                margin-left 8px
                            &:last-child
                                margin-right 0
                            > span
                                margin-left 24px
                                line-height 24px
                                .item-checked
                                    line-height 0
                                    position absolute
                                    display block
                                    left 0
                                    top 5px
                                    width 16px
                                    height 16px
                                    .ivu-checkbox
                                        &:not(.ivu-checkbox-checked)
                                            .ivu-checkbox-inner
                                                background-color var(--bg-color-tertiary)
                 .ivu-select-selection
                    width 100%
            .ivu-select-dropdown
                padding 6px
                box-shadow $box-shadow
                border-radius 8px
            .ivu-select-arrow
                right 2px
            .dialog-btnbox-normal
                margin-top 22px
</style>

<template>
    <div class="outputPPT-mask">
        <Dialog class="outputPPT-modal" :title="$t(exportType)" :isShow="true" @close="cancel">
            <div class="outputPPT-container">
                <div class="outputPPT-box">
                    <p class="outputPPT-optionbox-title" :title="$t('subTitle-name')">{{ $t("subTitle-name") }}</p>
                    <Input class="outputImg-selector right" v-model="fileName" size="small" :placeholder="fileNameSync" :disabled="EDCONFIG.IS_SDK" />
                </div>
                <div class="outputPPT-shapebox outputPPT-box">
                    <p class="outputPPT-optionbox-title">{{ $t("subTitle-range") }}</p>
                    <i-select class="outputImg-selector right" v-model="shapeRadio" size="small">
                        <i-option v-for="item in shapeList" :value="item.id" :key="item.id">
                            {{ $t(item.name) }}
                        </i-option>
                    </i-select>
                </div>
                <div class="outputPPT-watermarkBox outputPPT-box">
                    <p class="outputPPT-optionbox-title" :title="$t('subTitle-watermark')">{{ $t("subTitle-watermark") }}</p>
                    <div class="right">
                        <div
                            v-for="item in watermarkList"
                            :key="item.id"
                            class="check-box-item"
                            :class="{ checked: item.id == watermarkSetting }"
                            @click="changeWatermarkSetting(item.id)"
                        >
                            <VipIcon v-if="!vip && item.showVip" />
                            <span>{{ $t(item.name) }}</span>
                            <iconSymbol name="export-tick-top" class="tick-icon" />
                        </div>
                    </div>
                </div>
                <div class="outputPPT-zoombox outputPPT-box">
                    <p class="outputPPT-optionbox-title" :title="$t('subTitle-zoom')">{{ $t("subTitle-zoom") }}</p>
                    <div class="right">
                        <Slider :max="100" :min="0" v-model="zoomVal"></Slider>
                        <InputNumber
                            class="input-num"
                            :max="100"
                            :min="0"
                            style="width: 80px"
                            size="small"
                            v-model="zoomVal"
                            :active-change="false"
                            :formatter="(value) => `${value}%`"
                            :parser="(value) => value.replace('%', '')"
                            @keyup.enter.native="iviewInputBlur($event)"
                        ></InputNumber>
                    </div>
                </div>
                <div class="outputPPT-otherbox outputPPT-box">
                    <p class="outputPPT-optionbox-title" :title="$t('subTitle-other')">{{ $t("subTitle-other") }}</p>
                    <div class="right">
                        <div v-for="item in exportSetting" :key="item.id" class="export-setting" @click="changeExportSetting(item.id)">
                            <span>
                                <span class="item-checked">
                                    <Checkbox :value="item.check" />
                                </span>
                                {{ $t(item.name) }}
                            </span>
                            <VipIcon v-if="!vip" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="dialog-btnbox-normal" :style="{ direction: !internal ? 'ltr' : 'rtl' }">
                <div @click="cancel">{{ $t("cancel") }}</div>
                <div class="dialog-btn-ok" @click="beforeConfirm">
                    <span>{{ $t("export") }}</span>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";

    declare var WordExport: any;
    declare var PPTExport: any;
    declare var XLExport: any;

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            Dialog,
        },
    })
    export default class ouputPPTExcelWord extends Vue {
        @Inject()
        ["iviewInputBlur"];
        @Inject()
        ["fileRename"];
        haswatermark: boolean = false;
        zoomVal: number = 50;
        shapeRadio = 0;
        fileName = window["_view"]._doc._fileName;
        shapeList: Array<object> = [
            {
                id: 0,
                name: "currentPage",
            },
            {
                id: 1,
                name: "allPage",
            },
        ];
        exportSetting = [
            {
                id: 0,
                name: "exportBG",
                check: false,
            },
            {
                id: 1,
                name: "exportGroup",
                check: false,
            },
        ];
        watermarkSetting: number = 1;
        watermarkList = [
            {
                id: 0,
                name: "default",
            },
            {
                id: 1,
                name: "nonwatermark",
                showVip: true,
            },
        ];
        customWatermarkaName: string = "";
        customRangeName: string = "";

        get exportType() {
            return this.$store.state.dialog.exportType;
        }

        changeWatermarkSetting(id: number) {
            this.watermarkSetting = id;
        }

        changeExportSetting(id: number) {
            for (let index in this.exportSetting) {
                if (this.exportSetting[index].id == id) {
                    this.exportSetting[index].check = !this.exportSetting[index].check;
                    break;
                }
            }
        }
        beforeConfirm() {
            this.fileRename(this.fileName).then(() => {
                this.confirm();
            });
        }
        confirm() {
            this.setExporCustomPrefer();
            let needVip = this.exportSetting.some((item) => item.check);
            if ((this.watermarkSetting == 1 || needVip) && !this.vip) {
                let typeTiggerName;
                switch (this.exportType) {
                    case "Word":
                        typeTiggerName = "word";
                        break;
                    case "PowerPoint":
                        typeTiggerName = "ppt";
                        break;
                    case "Excel":
                        typeTiggerName = "excel";
                        break;
                }
                let rangeTiggerName;
                switch (this.shapeRadio) {
                    case 0:
                        rangeTiggerName = "_Currentpage";
                        break;
                    case 1:
                        rangeTiggerName = "_Allpage";
                        break;
                }
                let watermarkTiggerName = this.watermarkSetting == 1 ? "_Nomark" : "_Default";
                let otherSettingTiggerName = this.exportSetting[0].check ? "_Background" : "";
                otherSettingTiggerName += this.exportSetting[1].check ? "_Group" : "";
                let triggerName = typeTiggerName + rangeTiggerName + watermarkTiggerName + otherSettingTiggerName;
                if (window.EDCONFIG.IS_SDK) {
                    triggerName += "_exportSth";
                }
                this.$openBuyPage(triggerName);
                return;
            }

            if (!this.exportLoadedStatus) {
                this.exportLoadedStatus = 1;
                this.$store.dispatch("loadConfig", ["ExpXml4Office.tar"]).then((e) => {
                    this.exportLoadedStatus = 2;
                    this.exportOffice();
                });
            } else if (this.exportLoadedStatus == 2) {
                this.exportOffice();
            }

            this.closeModal();
        }
        exportOffice() {
            let view = window["_view"];
            this.$track("menu", "file", "output data " + this.exportType);
            this.$store.commit("setState", {
                type: "is_export_file",
                data: "exportFile",
            });
            let saveToInclowdz = (data) => {
                let reader = new FileReader();
                reader.onload = function (e) {
                    window.parent.postMessage(
                        {
                            mode: "iframe2parent",
                            target: "file",
                            action: "export",
                            type: "request",
                            session_id: "0000000003",
                            version: "v1",
                            data: {
                                filename: data.name,
                                filesize: data.size,
                                base64_data: (<any>e.target).result,
                            },
                        },
                        "*"
                    );
                };
                reader.readAsDataURL(data.blob);
            };
            let haswatermark = this.watermarkSetting == 1 ? false : true;
            switch (this.exportType) {
                case "Word":
                    this.$pcTrack("saveFileProcess_pickAnExportType", `fileType: word`);
                    let wordexp = new WordExport(view._doc, haswatermark);
                    wordexp.SetOptions(this.zoomVal / 100, this.exportSetting[1].check, this.exportSetting[0].check, this.shapeRadio == 0);
                    if (this.isInclowdz) {
                        wordexp.Export(saveToInclowdz);
                    } else {
                        try {
                            wordexp.Export();
                            this.sensors.track("exportSuccess", {
                                Catalogues: "saveFileProcess",
                                savesource: "exportSave",
                                file_type: "word",
                                export_order: 1,
                            });
                        } catch (e) {
                            console.log(e);
                        }
                    }
                    this.sensors.track("pickAnExportType", {
                        Catalogues: "saveFileProcess",
                        savesource: "exportSave",
                        file_type: "word",
                    });
                    break;

                case "PowerPoint":
                    this.$pcTrack("saveFileProcess_pickAnExportType", `fileType: ppt`);
                    let pptexp = new PPTExport(view._doc, haswatermark);
                    pptexp.SetOptions(this.zoomVal / 100, this.exportSetting[1].check, this.exportSetting[0].check, this.shapeRadio == 0);
                    if (this.isInclowdz) {
                        pptexp.Export(saveToInclowdz);
                    } else {
                        try {
                            pptexp.Export();
                            this.sensors.track("exportSuccess", {
                                Catalogues: "saveFileProcess",
                                savesource: "exportSave",
                                file_type: "ppt",
                                export_order: 1,
                            });
                        } catch (e) {
                            console.log(e);
                        }
                    }
                    this.sensors.track("pickAnExportType", {
                        Catalogues: "saveFileProcess",
                        savesource: "exportSave",
                        file_type: "ppt",
                    });
                    break;

                case "Excel":
                    this.$pcTrack("saveFileProcess_pickAnExportType", `fileType: excel`);
                    let excelexp = new XLExport(view._doc, haswatermark);
                    excelexp.SetOptions(this.zoomVal / 100, this.exportSetting[1].check, this.exportSetting[0].check, this.shapeRadio == 0);
                    if (this.isInclowdz) {
                        excelexp.Export(saveToInclowdz);
                    } else {
                        try {
                            excelexp.Export();
                            this.sensors.track("exportSuccess", {
                                Catalogues: "saveFileProcess",
                                savesource: "exportSave",
                                file_type: "excel",
                                export_order: 1,
                            });
                        } catch (e) {
                            console.log(e);
                        }
                    }
                    this.sensors.track("pickAnExportType", {
                        Catalogues: "saveFileProcess",
                        savesource: "exportSave",
                        file_type: "excel",
                    });
                    break;
            }
        }
        cancel() {
            this.closeModal();
        }
        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        get fileNameSync() {
            return this.$store.state.ui.fileNameSync;
        }
        get userInfo() {
            return this.$store.state.user.userInfo;
        }
        // 用户偏好
        get customPreferContent() {
            return this.$store.state.ui.customPreferContent;
        }
        set customPreferContent(v) {
            this.$store.commit("setStatus", {
                type: "customPreferContent",
                data: v,
            });
        }
        setExporCustomPrefer() {
            let data = this.customPreferContent || {};
            if (data[this.customWatermarkaName] === this.watermarkSetting && data[this.customRangeName] === this.shapeRadio) return;
            switch (this.exportType) {
                case "Word":
                    Object.assign(data, {
                        defaultExportWordWatermark: this.watermarkSetting,
                        defaultExportWordRange: this.shapeRadio,
                    });
                    break;
                case "PowerPoint":
                    Object.assign(data, {
                        defaultExportPPTWatermark: this.watermarkSetting,
                        defaultExportPPTRange: this.shapeRadio,
                    });
                    break;
                case "Excel":
                    Object.assign(data, {
                        defaultExportExcelWatermark: this.watermarkSetting,
                        defaultExportExcelRange: this.shapeRadio,
                    });
                    break;
            }

            this.customPreferContent = data;
            let jsonStr = JSON.stringify(data);
            let params = {
                id: this.userInfo.user_id,
                token: this.userInfo.token,
                obj: { content: jsonStr },
            };
            this.$edApi.updateUserPrefer(params);
        }

        get exportLoadedStatus() {
            return this.$store.state.ui.exportLoadedStatus;
        }
        set exportLoadedStatus(v) {
            this.$store.commit("setStatus", {
                type: "exportLoadedStatus",
                data: v,
            });
        }

        mounted() {
            this.$nextTick(() => {
                switch (this.exportType) {
                    case "Word":
                        this.customWatermarkaName = "defaultExportWordWatermark";
                        this.customRangeName = "defaultExportWordRange";
                        break;
                    case "PowerPoint":
                        this.customWatermarkaName = "defaultExportPPTWatermark";
                        this.customRangeName = "defaultExportPPTRange";
                        break;
                    case "Excel":
                        this.customWatermarkaName = "defaultExportExcelWatermark";
                        this.customRangeName = "defaultExportExcelRange";
                        break;
                }
                // 获取用户最后一次水印选项 默认无水印
                this.watermarkSetting = this.customPreferContent?.[this.customWatermarkaName] === 0 ? 0 : 1;
                // 获取用户最后一次导出范围选项
                this.shapeRadio = this.customPreferContent?.[this.customRangeName] || 0;
            });
        }
    }
</script>
<i18n>
{
  "zh": {
    "PowerPoint": "导出为PPT",
    "Word": "导出为Word",
    "Excel": "导出为Excel",
    "subTitle-name": "文件名称：",
    "subTitle-range": "导出范围：",
    "subTitle-watermark": "水印设置：",
    "subTitle-zoom": "缩放比例：",
    "subTitle-other": "其他设置：",
    "export": "导出",
    "cancel": "取消",
    "default": "默认",
    "nonwatermark": "无水印",
    "currentPage": "当前页面",
    "allPage": "所有页面",
    "exportBG": "导出背景",
    "exportGroup": "作为组合对象导出"
  },
  "en": {
    "PowerPoint": "Export to PPT",
    "Word": "Export to Word",
    "Excel": "Export to Excel",
    "subTitle-name": "File Name:",
    "subTitle-range": "Export range:",
    "subTitle-watermark": "Watermark settings:",
    "subTitle-zoom": "Zoom to:",
    "subTitle-other": "Other settings:",
    "export": "Export",
    "cancel": "Cancel",
    "default": "Default",
    "nonwatermark": "No watermarks",
    "currentPage": "Current page",
    "allPage": "All pages",
    "exportBG": "Export background",
    "exportGroup": "Export as group object"
  },
  "fr": {
    "PowerPoint": "Exporter vers PPT",
    "Word": "Exporter vers Word",
    "Excel": "Exporter vers Excel",
    "subTitle-name": "Nom de fichier:",
    "subTitle-range": "Plage d'exportation:",
    "subTitle-watermark": "Paramètres de filigrane:",
    "subTitle-zoom": "Mise à l'échelle:",
    "subTitle-other": "Autres paramètres:",
    "export": "Exporter",
    "cancel": "Annuler",
    "default": "Par défaut",
    "nonwatermark": "Aucun filigrane",
    "currentPage": "Page actuelle",
    "allPage": "Toutes les Pages",
    "exportBG": "Exporter l'arrière-plan",
    "exportGroup": "Exporter comme l'objet du groupe"
  },
  "de": {
    "PowerPoint": "Als PPT exportieren",
    "Word": "Als Word exportieren",
    "Excel": "Als Excel exportieren",
    "subTitle-name": "Dateiname:",
    "subTitle-range": "Exportbereich:",
    "subTitle-watermark": "Wasserzeicheneinstellungen:",
    "subTitle-zoom": "Zoomgröße:",
    "subTitle-other": "Andere Einstellungen:",
    "export": "Exportieren",
    "cancel": "Abbrechen",
    "default": "Standard",
    "nonwatermark": "Kein Wasserzeichen",
    "currentPage": "Aktuelle Seite",
    "allPage": "Alle Seite",
    "exportBG": "Hintergrund exportieren",
    "exportGroup": "Als Gruppenobjekt exportieren"
  },
  "jp": {
    "PowerPoint": "PPTにエクスポート",
    "Word": "Wordにエクスポート",
    "Excel": "Excelにエクスポート",
    "subTitle-name": "ファイル名：",
    "subTitle-range": "範囲をエクスポート:",
    "subTitle-watermark": "透かし設定: ",
    "subTitle-zoom": "ズーム倍率：",
    "subTitle-other": "その他の設定: ",
    "export": "エクスポート",
    "cancel": "キャンセル",
    "default": "デフォルト",
    "nonwatermark": "透かしなし",
    "currentPage": "現在のページ",
    "allPage": "すべてのページ",
    "exportBG": "背景をエクスポート",
    "exportGroup": "グループオブジェクトとしてエクスポート"
  },
  "es": {
    "PowerPoint": "Exportar a PPT",
    "Word": "Exportar a Word",
    "Excel": "Exportar a Excel",
    "subTitle-name": "Nombre de Archivo:",
    "subTitle-range": "Rango de exportación:",
    "subTitle-watermark": "Configuración de marca de agua:",
    "subTitle-zoom": "Tamaño de Zoom de:",
    "subTitle-other": "Otros ajustes:",
    "export": "Exportar",
    "cancel": "Cancelar",
    "default": "Estándar",
    "nonwatermark": "Sin marca de agua",
    "currentPage": "Página Actual",
    "allPage": "Todas las páginas",
    "exportBG": "Exportar fondo",
    "exportGroup": "Exportar como el objeto de grupo"
  },
  "pt": {
    "PowerPoint": "Exportar para PPT",
    "Word": "Exportar para Word",
    "Excel": "Exportar para Excel",
    "subTitle-name": "Nome do Arquivo:",
    "subTitle-range": "Intervalo de exportação:",
    "subTitle-watermark": "Configurações de marca d'água:",
    "subTitle-zoom": "Tamanho do Zoom do:",
    "subTitle-other": "Outras configurações:",
    "export": "Exportar",
    "cancel": "Cancelar",
    "default": "Padrão",
    "nonwatermark": "Sem marcas d'água",
    "currentPage": "Pagina Atual",
    "allPage": "Todas as páginas",
    "exportBG": "Exportar fundo",
    "exportGroup": "Exportar como objeto de grupo"
  },
  "it": {
    "PowerPoint": "Esporta in PPT",
    "Word": "Esporta in Word",
    "Excel": "Esporta in Excel",
    "subTitle-other": "Altre impostazioni:",
    "subTitle-range": "Range dell'esportazione:",
    "subTitle-watermark": "Impostazioni filigrana:",
    "subTitle-zoom": "Dimensioni zoom:",
    "subTitle-other": "Altre impostazioni:",
    "export": "Esporta",
    "cancel": "Annulla",
    "default": "Predefinito",
    "nonwatermark": "Nessuna filigrana",
    "currentPage": "Pagina Corrente",
    "allPage": "Tutte le Pagine",
    "exportBG": "Esporta sfondo",
    "exportGroup": "Esporta come oggetto-gruppo"
  },
  "tw": {
    "PowerPoint": "導出為PPT",
    "Word": "匯出為Word",
    "Excel": "匯出為Excel",
    "subTitle-name": "檔案名稱：",
    "subTitle-range": "匯出範圍：",
    "subTitle-watermark": "浮水印設定：",
    "subTitle-zoom": "縮放比例：",
    "subTitle-other": "其他設定:",
    "export": "匯出",
    "cancel": "取消",
    "default": "默認",
    "nonwatermark": "無水印",
    "currentPage": "當前頁面",
    "allPage": "所有頁",
    "exportBG": "匯出背景",
    "exportGroup": "作為組合對象匯出"
  },
  "kr": {
    "PowerPoint": "PPT로 내보내기",
    "Word": "Word로 내보내기",
    "Excel": "Excel로 내보내기",
    "subTitle-name": "파일 이름:",
    "subTitle-range": "내보내기 범위:",
    "subTitle-watermark": "워터마크 설정:",
    "subTitle-zoom": "확대 사이즈:",
    "subTitle-other": "기타 설정:",
    "export": "내보내기 ",
    "cancel": "취소 ",
    "default": "기본",
    "nonwatermark": "워터마크 없음",
    "currentPage": "현재 페이지",
    "allPage": "모든 페이지",
    "exportBG": "배경 내보내기",
    "exportGroup": "그룹 항목으로 내보내기"
  },
  "id": {
    "subTitle-other": "Outras configurações:",
    "subTitle-range": "Rentang ekspor:",
    "subTitle-watermark": "Pengaturan watermark:",
    "subTitle-zoom": "Perbesar ke:",
    "subTitle-other": "Pengaturan lainnya:"
  }
}
</i18n>
